@charset "UTF-8";

/* src/app/forms/menu-creator/menu-creator.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.routeIcon {
  margin-right: 8px;
  display: flex;
  flex-direction: column;
}
.routeIconSvg {
  margin-right: 8px;
  display: flex;
  flex-direction: column;
}
.creator-main {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 10px;
  overflow: auto;
  font-family: var(--tem-font-family);
}
.tree-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .tree-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep nz-tree {
  flex: 1;
  overflow: auto;
}
.tree-node-row {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 2px;
  padding: 0 4px;
  border-radius: var(--tem-radius);
}
.node-label {
  cursor: pointer;
  margin-left: 2px;
  color: var(--tem-ink);
}
.node-actions {
  display: inline-flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: flex-end;
  visibility: hidden;
}
.tree-node-row:hover .node-actions {
  visibility: visible;
}
.tree-node-row.node-selected {
  background: var(--tem-accent-soft);
}
.edit-menu {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  margin-left: 5px;
}
.tree-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  margin-right: 5px;
}
.vertical-divider {
  height: auto;
}
.span1 {
  margin-left: 10px;
}
.actions-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.form-editing {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 6px;
  padding-top: 10px;
}
/*# sourceMappingURL=menu-creator.component.css.map */
